module.exports = __webpack_public_path__ + "static/media/titan_dark_logo.35da4bce.svg";